import {ReducerBuilder} from "co-redux-builders";
import BusinessType from "../../../../model/BusinessType";
import TaskBusinessTypeList from "../../../../ws/businessType/TaskBusinessTypeList";
import {PagerBackendProps} from "../../../../components/Pager";
import BusinessTypeListCardAdminActions from "./BusinessTypeListCardAdminActions";
import TaskBusinessTypeDelete from "../../../../ws/businessType/TaskBusinessTypeDelete";

interface InitialState {
    loading: boolean,
    businessTypes: BusinessType[],
    error: string,
    pager: PagerBackendProps,
}

const INITIAL_STATE: InitialState = {
    loading: false,
    businessTypes: [],
    error: '',
    pager: {
        current: 1,
        total_pages: 1
    },
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)

    .onEvent(TaskBusinessTypeDelete.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskBusinessTypeDelete.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })

    .onEvent(TaskBusinessTypeList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskBusinessTypeList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskBusinessTypeList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskBusinessTypeList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            businessTypes: payload.data,
            pager: payload.pager || oldState.pager,
        }
    })

    .onEvent(BusinessTypeListCardAdminActions.clearReducer, (oldState, payload) => INITIAL_STATE)

    .build()